<script setup lang="ts">
const background = computed(() => {
  return `url(${useCdnUrl()}/assets/single-dot.png)`;
});
</script>

<template>
  <div class="detail-block">
    <div class="detail-block-spacer">
      <img src="/assets/icons/arrow-dots.png" />
    </div>

    <div class="detail-block-details">
      <div class="detail-image">
        <slot name="image" />
      </div>

      <div class="detail-items">
        <h2><slot name="title" /></h2>

        <div>
          <slot name="description" />
        </div>

        <div>
          <slot name="items" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.detail-block {
  .detail-block-spacer {
    background-color: white;
    padding: 1rem 0 0.5rem 0;
    text-align: center;
  }

  .detail-block-details {
    border-bottom: 1px white dotted;
    border-top: 1px white dotted;
    display: flex;

    @media only screen and (max-device-width: 600px) {
      flex-direction: column;
    }

    > div {
      flex: 1;

      img {
        height: 100%;
        object-fit: cover;
        width: 100%;
      }
    }

    .detail-items {
      background-image: v-bind(background);
      border-left: 1px white dotted;
      padding: 8rem 4rem 4rem 8rem;
      position: relative;

      @media only screen and (max-device-width: 600px) {
        padding: 3rem 5rem;
      }

      &:before {
        background-color: #6734bb;
        content: "";
        height: 5rem;
        left: 0;
        position: absolute;
        top: 0;
        width: 5rem;

        @media only screen and (max-device-width: 600px) {
          height: 3rem;
          width: 3rem;
        }
      }

      h2 {
        //font-size: 5rem;
        font-size: min(10vw, 5.2rem);
        font-weight: 200;
        line-height: 1;
        margin: 0;
        padding: 0;
        text-transform: uppercase;
      }

      p,
      li {
        font-size: 1.6rem;
        font-weight: 200;
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        list-style-type: none;
        margin: 0;
        padding: 0;

        li {
          line-height: 1;
          padding-left: 3rem;
          position: relative;
          &:before {
            background: url(/assets/dots.png) no-repeat;
            content: "";
            height: 10px;
            left: 0;
            position: absolute;
            top: 0.5rem;
            width: 10px;
          }
        }
      }
    }
  }
}
</style>
